import React, { useEffect, useRef  } from "react";
import { Helmet } from "react-helmet-async";
import usePlayerUtils from "./hooks/usePlayerUtils";

export default function DynamicHead() {
    const { currentTrack } = usePlayerUtils();
    const scrollInterval = useRef(null);

    const titleBase  = "Cool Online Music";

    const description = currentTrack?.artist
        ? `${currentTrack.artist} - ${currentTrack.title} | Cool Online Music`
        : null;

    const fullTitle = description || titleBase;

      useEffect(() => {
    if (scrollInterval.current) {
      clearInterval(scrollInterval.current);
    }

    if (!fullTitle) return;

    if (fullTitle.length <= 43) {
      document.title = fullTitle;
      return;
    }

    let pos = 0;
    const space = " | ";
    const scrollText = fullTitle + space;

    scrollInterval.current = setInterval(() => {
      document.title = scrollText.slice(pos) + scrollText.slice(0, pos);
      pos = (pos + 1) % scrollText.length;
    }, 300);

    return () => clearInterval(scrollInterval.current);
  }, [fullTitle]);

    return (
        <Helmet>
            <title>{fullTitle}</title>
            <meta name="description" content={description} />
            <meta property="og:title" content={titleBase } />
            <meta property="og:description" content={description} />
        </Helmet>
    );
}